enum CouponType {
  Value = 'Value',
  Percent = 'Percent',
}

export default CouponType;
